module.exports = __webpack_public_path__ + "static/media/app5.3b299231.png";